<script>
  import { onMount } from "svelte";

  onMount(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 200);
  });
</script>

<style>
  .page {
    display: flex;
    flex-direction: column;
  }

  .page .page-header {
    background-color: var(--primary);
    background-image: url('../assets/images/wallpapers/case-study-header-bg.jpg');
    background-size: contain;
    padding: 32px 128px;
  }

  .page .page-header .title,
  .page .page-header .subtitle {
    color: var(--primary-text) !important;
  }

  .page .page-content {
    padding: 32px 128px;
  }
</style>

<main class="page">
  <div class="page-header">
    <h1 class="title">PPE Marketplace</h1>
    <h2 class="subtitle">Case Study</h2>
  </div>

  <div class="page-content">
    <h3 class="subtitle">Imagine a centralized listing of all available PPE inventory across a jurisdiction</h3>

    <section>
      <p>As the pandemic rages on, individuals, organizations and governments locally and 
        across borders are seeking increased transparency of available inventories of 
        personal protective equipment (PPE). After a short survey, we know many vendors 
        have available PPE sitting idle in warehouses because they are unable to show 
        their inventory across an integrated network. The time is now to participate in 
        this transparent and centralized inventory system, and Curbza has launched it to 
        clear the path for better transparency across the region of available PPE supplies.</p>
    </section>

    <section>
      <h3 class="">The Scenario</h3>
      <p>Canada Health Org (CHO) is an organization looking for remote suppliers to sell 
        personal protective equipment throughout the nation.</p>
      <p>Keeping the health and well-being of Canadians above all else, CHO wants to provide 
        Canadians in far-reaching regions and rural areas with the speed and quality afforded 
        to urbanites, to procure the equipment they need to combat COVID-19.</p>
    </section>

    <section>
      <h3>The Challenge</h3>
      <p>CHO continues to receive many complaints of PPE shortages, even though much of the 
        initial PPE supply chain issues have been fixed. CHO has determined there is enough 
        PPE supply available in most regions; however, current PPE buyers are not aware of 
        many regional PPE vendors or where they're located. How can CHO find and compile 
        all of the PPE information it needs to quickly assist its clients?</p>
      <p>That's where Curbza comes in.</p>
    </section>

    <section>
      <h3>The Strategy</h3>

      <p>Research: The Curbza team finds out all of your pain points, and we brainstorm 
        together to find a solution that will promptly meet your needs. With the purpose of 
        fighting and winning over COVID-19, we look to the clients, but also to those around 
        us and beyond, to gather all the data we need to strengthen the marketplace for you.</p>

      <p>Work in Real-Time: It's critical to get personal protective equipment into the 
        hands of all who need it in a speedy manner. Our real-time analytics will provide 
        you with PPE availability, demand and successful matches from buyer to vendor.</p>

      <p>Quality Assurance: Any approved supplier is listed, and Curbza's Quality Control 
        features will ensure that everyone gets the quality PPE's they need and deserve 
        for their well-being and peace-of-mind.</p>

      <p>Always Here: Our Customer Support team welcomes your questions, concerns, 
        and any feedback that you have. We will respond to you at the quick and will keep 
        our communication open for you.</p>
    </section>

    <section>
      <h3>Psychological Impact</h3>

      <p>With the PPE Marketplace, CHO will again provide Canadians with the feeling of 
        security and safety, as it always has, even in the face of the global pandemic. 
        Buyers will feel more assured they're getting essential high-quality PPE 
        from certified suppliers. Vendors will have more peace-of-mind knowing that 
        their PPE is reaching customers, and production and profit will continue.</p>
    </section>
  
    <section>
      <h3>The Takeaway</h3>

      <p>Now that Canada Health Org is using Curbza's PPE Marketplace, it can help bring 
        PPE inventory to distant jurisdictions, and provide a greater sense of security 
        nationwide during the pandemic. Come and see what our PPE Marketplace has to 
        offer you! Check out our live demo or request a tour today.</p>
    </section>
  </div>
</main>